import React from 'react';


// <CameraMedia slideType={slideType} noVideo={this.disconnectedVideo} index={i} video={v.video}
class CameraMedia extends React.Component {

	state = {
		videoSrc: this.props.video,
		loading : true,
	}
	// 이는 render 메서드에서 생성된 DOM 노드나 React 엘리먼트에 접근하는 방법을 제공
	videoElement = React.createRef(null); 
	componentDidMount(){
		if(this.videoElement && this.props.video){
				var parentProp = this.props;
				if(this.state.videoSrc.active){
					this.videoElement.current.srcObject = this.state.videoSrc; 
					// ref 어트리뷰트가 커스텀 클래스 컴포넌트에 쓰였다면, 
					// ref 객체는 마운트된 컴포넌트의 인스턴스를 current 프로퍼티의 값으로 받음

					this.videoElement.current.addEventListener('loadedmetadata', function(e) {
						
						if(this.offsetHeight && this.offsetHeight !== this.parentNode.offsetHeight){
							
							parentProp.noVideo(parentProp.index)
						}
					});
					var playPromise = this.videoElement.current.play();
					if (playPromise !== undefined) {
						playPromise.then(_ => {
						  // Automatic playback started!
						  // Show playing UI.
						  this.videoElement.current.play()
						})
						.catch(error => {
						  // Auto-play was prevented
						  // Show paused UI.
						  this.props.noVideo(this.props.index);
						 
						});
					  }else{
						this.props.noVideo(this.props.index);
					  }
				}else{
					this.props.noVideo(this.props.index);
				}
			
				
			
		}
	}
	shouldComponentUpdate(nextProps, nextState) {
        return nextProps.video !== this.props.video;
	}
	 getStyle(oElm, strCssRule){
		var strValue = "";
		if(document.defaultView && document.defaultView.getComputedStyle){
			strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
		}
		else if(oElm.currentStyle){
			//eslint-disable-next-line
			strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
				return p1.toUpperCase();
			});
			strValue = oElm.currentStyle[strCssRule];
		}
		return strValue;
	}
	render(){
		return(
			<>
				<video ref={this.videoElement} id={`cctv-video-${this.props.index}`} className={`cctv-video`} playsInline autoPlay muted></video>	
			</>
		)
	}
	
}

export default CameraMedia;